import type { ApprovalSettings } from './types';

/**
 * Returns true if the `serviceKind` is not `launchdarkly`,
 * indicating that the environment is configured to use an external system for reviewing approval requests.
 */
export function hasIntegrationApproval(approvalSettings?: ApprovalSettings) {
  return approvalSettings ? approvalSettings.serviceKind !== 'launchdarkly' : false;
}
